import React from "react";
import { TextField, If } from "components/support";
import { fn } from "util";

export default props => {
  const options = {};

  if (fn.isBlank(props.value)) {
    options.value = "Não Informado";
  } else {
    options.value = `${props.value}`;

    if (props.mask) {
      options.maskPattern = props.mask;
    }

    if (props.type === "password") {
      options.type = "password";
    }
  }

  return (
    <div
      style={{
        paddingTop: "8px",
        paddingBottom: "8px",
        fontSize: "21px",
        color: "#212539"
      }}
    >
      <If test={props.label}>
        <strong style={{ fontSize: "0.8em", paddingLeft: "4px" }}>
          {props.label}
        </strong>
      </If>

      <TextField
        noMargin
        mask
        disabled
        fullWidth
        multiLine={props.multiLine}
        {...options}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/support/description-field/index.jsx